<template>
  <WizardContainer
    width="792px"
    height="624px"
  >
    <WizardContent>
      <h4 class="mt-6 mb-9">
        Datapeople is under maintenance
      </h4>
      <img
        src="@/assets/app-maintenance.svg"
        alt="App Maintenance"
        width="325px"
      >
      <p class="p3 mb-6">
        You will be able to login as soon as it is complete. Questions? Please reach out to
        <a :href="'mailto:support@datapeople.io?subject=App%20Maintenance'">
          support@datapeople.io
        </a>.
      </p>
    </WizardContent>
  </WizardContainer>
</template>

<script>
import WizardContainer from '@/components/shared/WizardContainer.vue';
import WizardContent from '@/components/shared/WizardContent.vue';

export default {
  name: 'AppMaintenance',
  components: {
    WizardContainer,
    WizardContent,
  },
  emits: ['track-page-load'],
  beforeCreate() {
    this.$emit('track-page-load', { page: 'App Maintenance' });
  },
};
</script>
